export default __webpack_public_path__ + "static/media/11.7510c53a.png";